module.exports = __webpack_public_path__ + "static/how-to-pay-4-927a343cc74657b0abb030345f5259ee.png";